import { Dialog, Stack, Text, Box, Button } from "@origin-digital/ods-core";
import React from "react";
import { DuplicateRequestDialogProps } from "./types";
import { useDuplicateRequestDialogContext } from "./context";

export const DuplicateRequestDialog = ({
  onDuplicateRequest,
}: DuplicateRequestDialogProps) => {
  const onDuplicate = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onDuplicateRequest();
    closeDialog();
  };
  const { closeDialog, id } = useDuplicateRequestDialogContext();

  return (
    <Dialog
      id={id}
      open={true}
      title="Duplicate this request?"
      // hideClose={false}
      onClose={() => closeDialog()}
    >
      <Stack space="small">
        {/* Content */}
        <Stack space="medium">
          <Text>
            If another similar request is needed, this will create a new copy
            (e.g. for another unit with similar connection details).{" "}
          </Text>
          <Text>
            Please ensure that all information is still relevant after you've
            updated the unit number, account details etc. Additionally, ensure
            that any necessary attachments are uploaded, as each request
            requires its own set of documents.
          </Text>
        </Stack>

        {/* End Content */}

        {/* Actions */}
        <Box
          position={{
            lg: "static",
            xs: "fixed",
          }}
          paddingTop={{
            lg: "medium",
            xs: "medium",
          }}
          paddingBottom={{
            lg: "none",
            xs: "large",
          }}
          paddingX={{
            lg: "none",
            xs: "medium",
          }}
          backgroundColor="white"
          width="full"
          style={{
            left: "0",
            bottom: "0",
            zIndex: "1",
          }}
        >
          <Box
            display="flex"
            flex-wrap={{
              lg: "noWrap",
              xs: "wrap",
            }}
            justifyContent="flex-end"
            alignItems="center"
          >
            <Box marginRight="large">
              <Button
                color="primary"
                variant="text"
                onClick={() => closeDialog()}
              >
                Cancel
              </Button>
            </Box>
            <Button onClick={(e) => onDuplicate(e)}>Duplicate</Button>
          </Box>
        </Box>
        {/* End Actions */}
      </Stack>
    </Dialog>
  );
};
